// trainingService.js
import { apiClient, API_ENDPOINTS } from './api';

export const trainingService = {
  // Получить обучения сотрудника
  async getByEmployee(employeeId) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.TRAININGS_EMPLOYEE(employeeId));
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка загрузки обучений для сотрудника ${employeeId}:`, error);
      throw error;
    }
  },

  // Назначить обучение
  async assign(data) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.TRAININGS_ASSIGN, data);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка назначения обучения:', error);
      throw error;
    }
  },

  // ОТМЕТИТЬ КАК ПРОЙДЕННОЕ - PUT /trainings/{id}/certificate
  async complete(id, data) {
    try {
      // Используем правильный эндпойнт: /trainings/{id}/certificate
      const endpoint = API_ENDPOINTS.TRAINING_CERTIFICATE(id);
      console.log(`Завершение обучения ID ${id}, endpoint: ${endpoint}`);
      
      const payload = {
        certificate_number: data.certificate_number || null,
        completed_date: data.completed_date
      };
      
      const response = await apiClient.put(endpoint, payload);
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка завершения обучения ${id}:`, error);
      throw error;
    }
  },

  // Загрузить сертификат с файлом
  async uploadCertificate(id, formData) {
    try {
      const endpoint = API_ENDPOINTS.TRAINING_CERTIFICATE(id);
      console.log(`Загрузка сертификата для обучения ID ${id}, endpoint: ${endpoint}`);
      
      // Для FormData не нужно Content-Type, браузер установит multipart/form-data
      const response = await apiClient.uploadFilePut(endpoint, formData.get('certificate_file'), 'certificate_file', {
        completed_date: formData.get('completed_date'),
        certificate_number: formData.get('certificate_number') || ''
      });
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка загрузки сертификата для обучения ${id}:`, error);
      throw error;
    }
  },

  // ПРОДЛИТЬ ОБУЧЕНИЕ - PUT /trainings/{id}/extend
  async extend(id, options) {
    try {
      // Используем правильный эндпойнт: /trainings/{id}/extend
      const endpoint = API_ENDPOINTS.TRAINING_EXTEND(id);
      console.log(`Продление обучения ID ${id}, endpoint: ${endpoint}`);
      
      let payload;
      if (options.months) {
        // Продление на количество месяцев
        payload = { months: options.months };
      } else if (options.new_expiration_date) {
        // Продление до конкретной даты
        payload = { new_expiration_date: options.new_expiration_date };
      } else {
        // По умолчанию - на 12 месяцев
        payload = { months: 12 };
      }
      
      const response = await apiClient.put(endpoint, payload);
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка продления обучения ${id}:`, error);
      throw error;
    }
  },

  // Удалить обучение
  async delete(id) {
    try {
      const endpoint = API_ENDPOINTS.TRAINING(id);
      console.log(`Удаление обучения ID ${id}, endpoint: ${endpoint}`);
      
      await apiClient.delete(endpoint);
      return { success: true };
    } catch (error) {
      console.error(`Ошибка удаления обучения ${id}:`, error);
      throw error;
    }
  },

  // Обновить статус обучения (если есть отдельный эндпойнт)
  // Если такого эндпойнта нет, можно использовать PATCH /trainings/{id}
  async updateStatus(id, status) {
    try {
      const endpoint = API_ENDPOINTS.TRAINING(id);
      const response = await apiClient.patch(endpoint, { status });
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка обновления статуса обучения ${id}:`, error);
      throw error;
    }
  },

  // Обновить метаданные (номер сертификата, НПА)
  async updateMetadata(id, metadata) {
    try {
      const endpoint = API_ENDPOINTS.TRAINING(id);
      const response = await apiClient.patch(endpoint, metadata);
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка обновления метаданных обучения ${id}:`, error);
      throw error;
    }
  },

  // Получить статистику обучений
  async getStatistics() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.TRAININGS_STATISTICS);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка загрузки статистики обучений:', error);
      throw error;
    }
  },

  // Экспорт обучений
  async exportTrainings(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = queryString 
        ? `${API_ENDPOINTS.TRAININGS_EXPORT}?${queryString}`
        : API_ENDPOINTS.TRAININGS_EXPORT;
      const response = await apiClient.get(url);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка экспорта обучений:', error);
      throw error;
    }
  },

  // Поиск обучений
  async searchTrainings(query) {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.TRAININGS_SEARCH}?q=${encodeURIComponent(query)}`);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка поиска обучений:', error);
      throw error;
    }
  },

  // Получить обучения бригады
  async getByBrigade(brigadeId) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.TRAININGS_BRIGADE(brigadeId));
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка загрузки обучений для бригады ${brigadeId}:`, error);
      throw error;
    }
  },

  // Просроченные обучения
  async getExpired() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.TRAININGS_EXPIRED);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка загрузки просроченных обучений:', error);
      throw error;
    }
  },

  // Истекающие обучения
  async getExpiring(days = 30) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.TRAININGS_EXPIRING(days));
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка загрузки истекающих обучений (${days} дней):`, error);
      throw error;
    }
  }
};